import { render } from "./BsHeaderView.vue?vue&type=template&id=c87cb7e0&scoped=true"
import script from "./BsHeaderView.vue?vue&type=script&lang=js"
export * from "./BsHeaderView.vue?vue&type=script&lang=js"

import "./BsHeaderView.vue?vue&type=style&index=0&id=c87cb7e0&scoped=true&lang=css"

import exportComponent from "/Users/mae/Dev/mamp/htdocs/mfj_renewal/manage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c87cb7e0"]])

export default __exports__